import { createSelector } from 'reselect';
import dedupeObjectArray from '../../../shared/helpers/dedupeObjectArray';
import normalizer from '../../normalizer';
import getPriceDisplay from '../../../shared/helpers/getPriceDisplay';
import {
  getBogoPromotions,
  getAddonPromotionForProduct,
} from '../../../shared/helpers/promotionsHelper';


const getProduct = state => state.product.details;

export const getAddOns = state => state.addOns;

export const getNormalizedProduct = createSelector(
  getProduct, product => normalizer(product),
);

export const getCarouselImages = createSelector( // eslint-disable-line
  getProduct,
  (product) => {
    const { productLarge } = product.images;
    const imageCarousel = [];

    for (let i = 0; i < productLarge.length; i += 1) {
      imageCarousel.push(productLarge[i]);
    }

    return dedupeObjectArray(imageCarousel, 'url');
  },
);

export const getPrice = createSelector( // eslint-disable-line
  getProduct,
  ({ price, rebatePrice }) => {
    const priceDisplay = getPriceDisplay(price, rebatePrice);

    return { ...priceDisplay };
  },
);

const getEmptyInfoBanner = createSelector(
  getProduct,
  ({ attributeGroups, attributeGroups: { storefrontAttributes } }) => {
    if (!attributeGroups || !storefrontAttributes) {
      return {
        theme: '',
        message: '',
      };
    }
    return false;
  },
);

export const getInfoBanner = createSelector(
  getProduct,
  getEmptyInfoBanner,
  ({ attributeGroups }, emptyInfoBanner) => {
    if (emptyInfoBanner) {
      return emptyInfoBanner;
    }

    const {
      storefrontAttributes: {
        detailsInfoBannerTheme = {},
        detailsInfoBanner = {},
        showInfoBannerInDetails = {},
      },
    } = attributeGroups;

    return {
      theme: detailsInfoBannerTheme.value && detailsInfoBannerTheme.value[0].toLowerCase(),
      message: detailsInfoBanner.value && detailsInfoBanner.value[0],
      showInfoBannerInDetails: showInfoBannerInDetails.value && showInfoBannerInDetails.value[0],
    };
  },
);

export const filterHiddenPromotions = createSelector(
  getProduct,
  ({ hidePromotions, promotions }) => {
    if (hidePromotions) {
      return [];
    }

    return promotions || [];
  },
);

export const getPromotionBanners = createSelector(
  getProduct,
  ({ promotions, id }) => {
    const promotionBanners = getBogoPromotions(promotions);
    const addonPromo = getAddonPromotionForProduct(id);

    if (addonPromo) {
      promotionBanners.push(addonPromo);
    }

    return promotionBanners;
  },
);

export const getAddOnRestriction = createSelector(
  getAddOns,
  addOns => addOns.reduce((prev, { restricted }) => (restricted || prev), null),
);
